module.exports = __webpack_public_path__ + "static/img/yiNew4.21e293b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiNew4.jpg
// module id = Tfh1
// module chunks = 0